import { useState, useEffect, useCallback } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import Dialog from "./Dialog";
import { useTranslation } from "react-i18next";

const mapStyles = {
  width: "620px",
  maxWidth: "80vw",
  height: "300px",
  borderRadius: "5px",
  position: "static",
};

const MapsComponent = (props) => {
  const { t } = useTranslation();
  const [location, setlocation] = useState(null);
  const [placeDetails, setPlaceDetails] = useState(null);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState(1);

  useEffect(() => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, handleError, { timeout: 10000, enableHighAccuracy: true });
    }
  }, []);

  const getPlaceDetails = useCallback(
    async (location) => {
      const google = window.google;
      var geocoder = new google.maps.Geocoder();

      const latlng = { lat: parseFloat(location.loc_x), lng: parseFloat(location.loc_y) };

      geocoder.geocode({ location: latlng, region: t("language") === "en" ? "en" : "ar" }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            setPlaceDetails(results[0]);
            props.handleAddress({ formatted_address: results[0].formatted_address, location: latlng });
          } else {
            handleError({ message: "No results found" });
          }
        } else {
          handleError({ message: "Geocoder failed due to: " + status });
        }
      });
    },
    [props, t]
  );

  useEffect(() => {
    if (location) getPlaceDetails(location);
  }, [location]);

  const handleError = (e) => {
    setMessage(e.message);
    setType(2);
    setVisible((form) => true);
  };

  const showPosition = (position) => {
    setlocation({ loc_x: position.coords.latitude, loc_y: position.coords.longitude });
  };

  const saveCoords = (mapProps, map, clickEven) => {
    setlocation({ loc_x: clickEven.latLng.lat(), loc_y: clickEven.latLng.lng() });
  };

  return (
    <div className="mt-5" style={{ height: "45vh", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Map
        google={props.google}
        style={mapStyles}
        containerStyle={mapStyles}
        zoom={16}
        onClick={saveCoords}
        center={{ lat: location && location.loc_x, lng: location && location.loc_y }}
        initialCenter={{ lat: location && location.loc_x, lng: location && location.loc_y }}
      >
        {placeDetails && (
          <Marker
            key={`marker-${placeDetails.formatted_address}`}
            position={{ lat: parseFloat(location.loc_x), lng: parseFloat(location.loc_y) }}
            title={placeDetails.formatted_address}
          />
        )}
      </Map>
      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </div>
  );
};

const LoadingContainer = (props) => (
  <div className="text-center">
    <div className="spinner-grow text-success" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  LoadingContainer: LoadingContainer,
})(MapsComponent);
